export function redirectToTrialConfiguration(accountUid: string) {
    window.location.href = `/app/accounts/${accountUid}/trial-configuration/`;
}
